import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEllipsisH,
  faEye,
  faEdit,
  faTrashAlt,
  faNetworkWired,
  faFileSignature,
  faBell,faAngleDown
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Button,
  Modal,
  Form,
  InputGroup,
  ButtonGroup,
  Card,
  Dropdown,
  Pagination,
  Nav,
  Table,
  Badge,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import axios from "axios";
import {
  getFetchContractsTemplate,
  deleteVendor,
  getAssets,
  createAssetAssign,
  updateVendorStatus,
} from "../../app/api";
import { dropdownItems } from "../../data/tables";
import{useFetchVendorsQuery ,useDeleteVendorMutation }from "../../store/app/apislice"
import Loader from "../../components/Loader";
import swal from "sweetalert";
const Vendors = () => {
  const [show, setShow] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [assetsList, setAssetsList] = useState([]);
  const [deleteVendor] = useDeleteVendorMutation();
  const [totalPages, setTotalPages] = useState(0); // State to hold total pages
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  // const [currentpage, setCurrentPage] = useState();
  const [vendorId, setVendorID] = useState("");
  const [statuses, setStatuses] = useState({});
  const [status, setStatus] = useState("");
  const [rgstrstatus, setRgstrStatus] = useState("");
  const [vendortype, setVendorType] = useState("");
  const [search, setSearch] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setVendorID(id);
  };
  const [isListView, setIsListView] = useState(() => {
    const savedView = localStorage.getItem("isListView");
    return savedView ? JSON.parse(savedView) : true; // Parse the value if it exists
  });

  const accesstoken = localStorage.getItem("adobe_access_token");
  const handleAdobeFetchContract = async () => {
    // Retrieve environment variables
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(getFetchContractsTemplate(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
          accessToken: accesstoken,
        },
      });
    
    } catch (error) {
     
    }
  };
  useEffect(() => {
    localStorage.setItem("isListView", JSON.stringify(isListView));
  }, [isListView]);
  useEffect(() => {
    const fetchAssetsList = async (currentPage) => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(getAssets(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
          params: {
            page: currentPage,
          },
        });
        // console.log(response.data);
        setAssetsList(response.data?.unasignAssets);
        handleAdobeFetchContract()
      } catch (error) {
        console.error("Error fetching vendors:", error);
      } finally {
        setLoading(false); // Hide loader after fetching data
      }
    };
    fetchAssetsList();
  }, []);
  const [position, setPosition] = useState([]);

  const handlePositionSelect = (e) => {
    const selectedId = e.target.value;
    const selectedPositon = dropdownItems.find(
      (positions) => positions.name === selectedId
    );

    // Avoid duplicates
    if (
      selectedPositon &&
      !position.some((positions) => positions.name === selectedId)
    ) {
      setPosition([...position, selectedPositon]);

      // console.log(position);
    }
  };

  const removePosition = (positionToRemove) => {
    setPosition(
      position.filter((positions) => positions.name !== positionToRemove.name)
    );
  };
  const [selectedAssets, setSelectedAssets] = useState([]);
  const handleAssetSelect = (e) => {
    const selectedId = e.target.value;
    const selectedAsset = assetsList.find((asset) => asset.id === selectedId);

    // Avoid duplicates
    if (
      selectedAsset &&
      !selectedAssets.some((asset) => asset.id === selectedId)
    ) {
      setSelectedAssets([...selectedAssets, selectedAsset]);
    }
  };

  const removeAsset = (assetToRemove) => {
    setSelectedAssets(
      selectedAssets.filter((asset) => asset.id !== assetToRemove.id)
    );
  };
  const {
    data: vendorData,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useFetchVendorsQuery({
    page,
    position: position.map((item) => item.value).join(","),
    register_status: rgstrstatus,
    status,
    vendor_type: vendortype,
    search,
  });
  // console.log("vendordata",vendorData)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);

    try {
      const token = localStorage.getItem("token");
      const assetIds = selectedAssets.map((asset) => asset.id);
      const AssestsData = {
        vendor_id: vendorId,
        asset_ids: assetIds,
      };
      let response;

      response = await axios.post(createAssetAssign(), AssestsData, {
        headers: {
          "Content-Type": "application/json", 
          "secret-key": process.env.REACT_APP_SECRET_KEY, 
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response)
      swal({
        text: response.data.message,
        icon: "success",
      }).then(() => {
        refetch()
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
      setShow(false);
      setSelectedAssets([]);
    }
  };
  const handleUpdateStatus = async (vendorId, newStatus) => {
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const AssestsData = {
        register_status: newStatus,
      };
      let response;

      response = await axios.put(updateVendorStatus(vendorId), AssestsData, {
        headers: {
          "Content-Type": "application/json", // Set Content-Type to application/json
          "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
          "auth-token": `Bearer ${token}`,
        },
      });
      // Update the local status state
      // console.log(response)
      setStatuses((prevStatuses) => ({
        ...prevStatuses,
        [vendorId]: newStatus,
      }));
      swal({
        text: response.data.message,
        icon: "success",
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (vendorId, newStatus) => {
    handleUpdateStatus(vendorId, newStatus); // Call the update function
  };



  useEffect(() => {
    refetch()
    if (vendorData) {
      setVendors(vendorData?.data);
      setTotalPages(vendorData?.pagination?.total_pages);

      const initialStatuses = vendorData?.data?.reduce((acc, vendor) => {
        acc[vendor.id] = vendor.register_status || "pending";
        return acc;
      }, {});
      setStatuses(initialStatuses);
    }
  }, [vendorData]);
  const handleDelete = async (id) => {
    try {
      const response = await deleteVendor(id).unwrap();
      console.log(response);

      swal({
        text: response.message,
        icon: "success",
      });

      refetch(); // Refresh the vendor list
    } catch (error) {
      console.error("Error deleting vendor:", error);
      swal({
        text:error.response.data.messages.error,
        icon: "error",
      });
    }
  };

  return (
    <>
      <div>
      <Row md={12} className="mb-2">
      <Col md={3}  >
            <h4 className="mb-0">Vendors Management</h4>
            {/* <p className="mb-0">Your web analytics dashboard template.</p> */}
          </Col>
          <Col md={3}  className="mb-sm-2">
          <Form.Group id="topbarSearch">
              <InputGroup className="input-group-merge search-bar">
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </Form.Group>
          </Col>
         
            
          <Col md={3} className="mb-sm-2 d-flex justify-content-end" >
            <ButtonGroup
          
             >
              <Button
                variant="outline-primary"
                style={{
                  backgroundColor: isListView ? "#262B40" : "transparent",
                  color: isListView ? "white" : "black",
                }}
                size="sm"
                onClick={() => setIsListView(true)}
              >
                List
              </Button>
              <Button
                variant="outline-primary"
                style={{
                  backgroundColor: !isListView ? "#262B40" : "transparent",
                  color: !isListView ? "white" : "black",
                }}
                size="sm"
                onClick={() => setIsListView(false)}
              >
                Grid
              </Button>
            </ButtonGroup>
            </Col>
            <Col md={3} className="mb-sm-2 d-flex justify-content-end" >
            <Button
              variant="primary"
              className=" me-2 "
              as={Link}
              to={Routes.AddVendor.path}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>New</span>
            </Button>
            </Col>
        </Row>

        <Row md={12}>
          <Col md={3} className="mb-sm-4 mb-4">
            
            <Form.Group id="status">
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="0">Select Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  className="mb-sm-4 mb-4">
            <Form.Group>
              <div
                style={{
                  position: "relative",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  // padding: "5px",
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  background: "white",
                }}
              >
                {position.map((positions) => (
                  <span
                    key={positions.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "2px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "3px",
                      padding: "5px",
                    }}
                  >
                    {positions.name}
                    <button
                      onClick={() => removePosition(positions)}
                      style={{
                        marginLeft: "5px",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#ce1126",
                      }}
                    >
                      x
                    </button>
                  </span>
                ))}

                <Form.Select
                  defaultValue="0"
                  onChange={handlePositionSelect}
                  style={{
                    border: "none",
                    outline: "none",
                    flex: "1",
                    minWidth: "150px",
                    boxShadow: "none",
                  }}
                >
                  <option value="">Select position</option>
                  {dropdownItems.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>
       
          <Col md={3} className="mb-sm-4 mb-4">
            <Form.Group id="filter Dropdown">
              <Form.Select
                value={vendortype}
                onChange={(e) => setVendorType(e.target.value)}
              >
                <option value="All">All</option>
                <option value="New">New</option>
                <option value="Recent Modified">Recent Modified</option>
              </Form.Select>
            </Form.Group>
          </Col>
        
          <Col md={3} className="mb-sm-4 mb-4">
            <Form.Group id="status">
              <Form.Select
                value={rgstrstatus}
                onChange={(e) => setRgstrStatus(e.target.value)}
              >
                <option value="0">Rgst Status</option>
                <option value="pending">Pending</option>
                <option value="approve">Approve</option>
                <option value="rejected">Rejected</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          {isListView ? (
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card
                border="light"
                className="table-wrapper table-responsive shadow-sm"
              >
                {/* <Card.Body className="pt-0"> */}
                <Table hover className="user-table align-items-center">
                  {isLoading || isFetching ? (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </div>
                  ) : (
                    <>
                      <thead>
                        <tr>
                          <th className="border-bottom">ID</th>
                          <th className="border-bottom">Vendor Name</th>
                          <th className="border-bottom">Vendor Email</th>
                          <th className="border-bottom">Status</th>
                          <th className="border-bottom">Assests Assign</th>
                          <th className="border-bottom">Reports</th>

                          <th className="border-bottom">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {vendors?.map((time, index) => (
                          <tr key={index}>
                            <td className="fw-normal">
                              <Link
                                className="Link_underline"
                                to={`${Routes.VendorDetail.path}/${time.id}`}
                              >
                                {time?.vendor_ID}
                              </Link>
                            </td>

                            <td>
                              <span className="fw-normal">
                                {time?.company_name}
                              </span>
                            </td>
                            <td>
                              <span className="fw-normal">{time?.email}</span>
                            </td>
                            <td>
                              <Dropdown
                                onSelect={(eventKey) =>
                                  handleStatusChange(time?.id, eventKey)
                                }
                              >
                                <Dropdown.Toggle
                                  variant="primary"
                                  id="dropdown-basic"
                                 
                                  className="Dropdown_selector"
                                >
                                  {statuses[time.id] || "pending"}<FontAwesomeIcon icon={faAngleDown} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item eventKey="pending">
                                    Pending
                                  </Dropdown.Item>
                                  <Dropdown.Item eventKey="approve">
                                    Approve
                                  </Dropdown.Item>
                                  <Dropdown.Item eventKey="rejected">
                                    Rejected
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>
                              <Button
                                variant="primary"
                                onClick={() => handleShow(time?.id)}
                                style={{
                                  borderRadius: "20px",
                                  padding: "0.4rem 1.2rem",
                                  fontSize: "0.85rem",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  className="me-2"
                                />
                                Asset
                              </Button>
                            </td>
                            <td>
                              <div className="d-flex gap-2 ">
                                <Badge
                                  pill
                                  bg="primary"
                                  title="Assets"
                                  style={{
                                    padding: "0.4rem 0.7rem",
                                    fontSize: "0.85rem",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {time.asset_count}&nbsp;&nbsp;
                                  <FontAwesomeIcon icon={faNetworkWired} />
                                </Badge>
                                <Badge
                                  pill
                                  bg="success"
                                      title="Reminders"
                                  style={{
                                    padding: "0.4rem 0.7rem",
                                    fontSize: "0.85rem",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {time.reminder_count}&nbsp;&nbsp;
                                  <FontAwesomeIcon icon={faBell} />
                                </Badge>
                                <Badge
                                  pill
                                  bg="danger"
                                      title="Contracts"
                                  style={{
                                    padding: "0.4rem 0.7rem",
                                    fontSize: "0.85rem",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {time.contract_count}&nbsp;&nbsp;
                                  <FontAwesomeIcon icon={faFileSignature} />
                                </Badge>
                              </div>
                            </td>

                            <td>
                              <Dropdown as={ButtonGroup}>
                                <Dropdown.Toggle
                                  as={Button}
                                  split
                                  variant="link"
                                  className="text-dark m-0 p-0"
                                >
                                  <span className="icon icon-sm">
                                    <FontAwesomeIcon
                                      icon={faEllipsisH}
                                      className="icon-dark"
                                    />
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item>
                                    <Link
                                      className="me-2"
                                      to={`${Routes.VendorDetail.path}/${time.id}`}
                                    >
                                      {" "}
                                      <FontAwesomeIcon
                                        icon={faEye}
                                        className="me-2"
                                      />{" "}
                                      View Details
                                    </Link>
                                  </Dropdown.Item>
                                  <Dropdown.Item>
                                    <Link
                                      as={Link}
                                      to={`${Routes.AddVendor.path}/${time.id}`}
                                    >
                                      <FontAwesomeIcon
                                        icon={faEdit}
                                        className="me-2"
                                      />{" "}
                                      Edit{" "}
                                    </Link>
                                  </Dropdown.Item>
                                  <Dropdown.Item className="text-danger">
                                    <div onClick={() => handleDelete(time.id)}>
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        className="me-2"
                                      />{" "}
                                      Remove
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </>
                  )}
                </Table>
              </Card>
            </Col>
          ) : (
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              {isLoading || isFetching  ? (
                <Loader />
              ) : (
                <Row>
                  {vendors?.map((vendor) => {
                    return (
                      <Col
                        key={vendor.id}
                        xs={12}
                        md={6}
                        sm={6}
                        lg={4}
                        xl={4}
                        className="mb-4"
                      >
                        <Card
                          style={{
                            borderRadius: "10px",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            overflow: "visible",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <Card.Body className="d-flex flex-column">
                            {/* Header Section */}
                            <div>
                              <Card.Title
                                style={{
                                  fontSize: "1.25rem",
                                  fontWeight: "600",
                                  color: "#333",
                                  marginBottom: "0.5rem",
                                  float: "left",
                                }}
                              >
                                <Link
                                  className="Link_underline"
                                  to={`${Routes.VendorDetail.path}/${vendor.id}`}
                                >
                                  {vendor.company_name}
                                </Link>
                              </Card.Title>
                              <Dropdown
                                style={{ float: "right" }}
                                as={ButtonGroup}
                              >
                                <Dropdown.Toggle
                                  as={Button}
                                  split
                                  variant="link"
                                  className="text-dark m-0 p-0"
                                >
                                  <span className="icon icon-sm">
                                    <FontAwesomeIcon
                                      icon={faEllipsisH}
                                      className="icon-dark"
                                    />
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item>
                                    <Link
                                      className="me-2"
                                      to={`${Routes.VendorDetail.path}/${vendor.id}`}
                                    >
                                      <FontAwesomeIcon
                                        icon={faEye}
                                        className="me-2"
                                      />
                                      View Details
                                    </Link>
                                  </Dropdown.Item>
                                  <Dropdown.Item>
                                    <Link
                                      as={Link}
                                      to={`${Routes.AddVendor.path}/${vendor.id}`}
                                    >
                                      <FontAwesomeIcon
                                        icon={faEdit}
                                        className="me-2"
                                      />{" "}
                                      Edit
                                    </Link>
                                  </Dropdown.Item>
                                  <Dropdown.Item className="text-danger">
                                    <div
                                      onClick={() => handleDelete(vendor.id)}
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        className="me-2"
                                      />{" "}
                                      Remove
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>

                            <div>
                              <Card.Text
                                style={{
                                  fontSize: "0.9rem",
                                  fontWeight: "500",

                                  float: "left",
                                  marginBottom: "0px",
                                }}
                              >
                                {vendor?.vendor_ID
                                  ? `${vendor?.vendor_ID}`
                                  : "N/A"}
                              </Card.Text>
                              <Card.Text
                                style={{
                                  fontSize: "0.9rem",

                                  float: "right",
                                  textAlign: "center",
                                  marginBottom: "0px",
                                }}
                              >
                                {vendor.email}
                              </Card.Text>
                            </div>
                            <div
                              style={{
                                // padding: "1rem",
                                borderBottom: "1px solid #e0e0e0",
                                textAlign: "center",
                                marginTop: "0.5rem",
                                display: "flex",
                              }}
                            ></div>

                            {/* Email Section */}

                            {/* Button and Dropdown */}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <Button
                                variant="primary"
                                onClick={() => handleShow(vendor?.id)}
                                style={{
                                  borderRadius: "20px",
                                  padding: "0.4rem 1.2rem",
                                  fontSize: "0.85rem",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  className="me-2"
                                />
                                Asset
                              </Button>

                              <Dropdown
                                onSelect={(eventKey) =>
                                  handleStatusChange(vendor.id, eventKey)
                                }
                              >
                                <Dropdown.Toggle
                                  variant="primary"
                                  id="dropdown-basic"
                                  className="Dropdown_selector"
                                >
                                  
                                  {statuses[vendor.id] || "pending"} <FontAwesomeIcon icon={faAngleDown} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                  style={{
                                    zIndex: 1000,
                                    position: "absolute",
                                    overflow: "visible",
                                  }}
                                >
                                  <Dropdown.Item eventKey="pending">
                                    Pending
                                  </Dropdown.Item>
                                  <Dropdown.Item eventKey="approve">
                                    Approve
                                  </Dropdown.Item>
                                  <Dropdown.Item eventKey="rejected">
                                    Rejected
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>

                            {/* Tags Section */}
                            <div className="mt-4 d-flex justify-content-center gap-2">
                              <Badge
                                pill
                                bg="primary"
                                style={{
                                  padding: "0.4rem 1rem",
                                  fontSize: "0.85rem",
                                  border: "1px solid #ddd",
                                }}
                              >
                                {vendor.asset_count}&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faNetworkWired} />
                              </Badge>
                              <Badge
                                pill
                                bg="success"
                                style={{
                                  padding: "0.4rem 1rem",
                                  fontSize: "0.85rem",
                                  border: "1px solid #ddd",
                                }}
                              >
                                {vendor.reminder_count}&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faBell} />
                              </Badge>
                              <Badge
                                pill
                                bg="danger"
                                style={{
                                  padding: "0.4rem 1rem",
                                  fontSize: "0.85rem",
                                  border: "1px solid #ddd",
                                }}
                              >
                                {vendor.contract_count}&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faFileSignature} />
                              </Badge>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </Col>
          )}
        </Row>
        <Nav className="justify-content-center mb-4">
          <Pagination className="mb-2 mb-lg-0">
            <Pagination.Prev
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === page}
                onClick={() => setPage(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            />
          </Pagination>
        </Nav>
        <Modal className="p-3 modal-cont" show={show} onHide={handleClose}>
          <Modal.Header className="p-3 contact_header">
            <Modal.Title className="contact_header_title">
              Assign Assets
            </Modal.Title>
            <Button
              variant="danger"
              onClick={handleClose}
              className="contact_header_Btn"
            >
              &times;
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center mb-2">
            <p className="pt-2 pb-2 mb-0">
                Select the Assests to Assign to the Vendor
              </p>
            </div>
            <Form onSubmit={handleSubmit}>
              <Form.Group>
                <Form.Label>Select Assets</Form.Label>
                <div
                  style={{
                    position: "relative",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "5px",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  {selectedAssets.map((asset) => (
                    <span
                      key={asset.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "2px",
                        backgroundColor: "#e0e0e0",
                        borderRadius: "3px",
                        padding: "5px",
                      }}
                    >
                      {asset.title}
                      <button
                        onClick={() => removeAsset(asset)}
                        style={{
                          marginLeft: "5px",
                          border: "none",
                          background: "none",
                          cursor: "pointer",
                          color: "#ce1126",
                        }}
                      >
                        x
                      </button>
                    </span>
                  ))}

                  <Form.Select
                    defaultValue="0"
                    onChange={handleAssetSelect}
                    style={{
                      border: "none",
                      outline: "none",
                      flex: "1",
                      minWidth: "150px",
                      boxShadow: "none",
                    }}
                  >
                    <option value="0" disabled>
                      Select Assets
                    </option>
                    {assetsList?.map((asset) => (
                      <option key={asset.id} value={asset.id}>
                        {asset.title}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </Form.Group>
              <div className="pt-3">
                <Button variant="primary" type="submit">
                  Assign Assests
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
export default Vendors;